import { observer } from 'mobx-react-lite';
import * as React from 'react';

import {
  ITableColumnModel,
  TableFactoryRowModel,
  TableFactoryStoreParams,
} from 'stores/common';

import { ControllersCellFactory } from '../ControllersCellFactory';

import s from './VirtualTableBody.module.scss';

type VirtualSummaryRowProps = {
  summaryRow?: TableFactoryRowModel | null;
  columns: ITableColumnModel[];
  tableParams: TableFactoryStoreParams;
};

const VirtualSummaryRow: React.FC<VirtualSummaryRowProps> = ({
  summaryRow,
  columns,
  tableParams,
}) => {
  if (!summaryRow) {
    return null;
  }

  return (
    <div className={s.virtualSummaryRow}>
      {columns.map((elem, index) => {
        const isFixed = index === 0;
        return (
          <div
            key={elem.data.id}
            className={`${s.virtualSummaryCell} ${isFixed ? s.fixedCell : ''}`}
            style={{
              width: 200,
              minWidth: 200,
            }}
          >
            {summaryRow?.cells[elem.data.id] && (
              <ControllersCellFactory
                record={summaryRow.cells[elem.data.id]}
                row={summaryRow}
                tableParams={tableParams}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default observer(VirtualSummaryRow);
